export const VIEW_NAMESPACE_NONE = 'NONE';